export default __webpack_public_path__ + "static/IT Support-b987e845c5f95e4c8a2188a0bd1162b4.png";